var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8155 3.73032L13.0791 13.5117L17.3838 14.716L20.1201 4.93455L15.8155 3.73032Z",
    fill: "#F7F8F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5134 0.847314L17.5702 0.0285409C17.194 -0.0821041 16.7957 0.139186 16.7072 0.515379L16.1982 2.30783L20.4913 3.5028L21.0002 1.71035C21.1109 1.35628 20.8896 0.95796 20.5134 0.847314Z",
    fill: "#F7F8F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3259 16.2048C12.2816 16.3597 12.3038 16.5146 12.348 16.6474L13.2996 18.971C13.4766 19.3693 13.9856 19.5242 14.3396 19.2586L16.3755 17.776C16.5083 17.6875 16.5968 17.5547 16.6189 17.4219L16.973 16.1384L12.6799 14.9435L12.3259 16.2048Z",
    fill: "#F7F8F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.06219 3.36999H12.9676C13.5651 3.36999 14.0298 2.88315 14.0298 2.3078C14.0298 1.73244 13.543 1.24561 12.9676 1.24561H1.06219C0.464709 1.24561 0 1.73244 0 2.3078C0 2.88315 0.486838 3.36999 1.06219 3.36999Z",
    fill: "#F7F8F9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6135 7.22046C12.6135 6.62297 12.1267 6.15826 11.5513 6.15826H1.06219C0.464709 6.15826 0 6.6451 0 7.22046C0 7.79581 0.486838 8.28265 1.06219 8.28265H11.5513C12.1488 8.30478 12.6135 7.81794 12.6135 7.22046Z",
    fill: "#F7F8F9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1793 11.0709H1.06219C0.464709 11.0709 0 11.5578 0 12.1331C0 12.7085 0.486838 13.1953 1.06219 13.1953H10.1793C10.7768 13.1953 11.2415 12.7085 11.2415 12.1331C11.2415 11.5578 10.7768 11.0709 10.1793 11.0709Z",
    fill: "#F7F8F9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.36057 16.0057H1.06219C0.464709 16.0057 0 16.4925 0 17.0679C0 17.6654 0.486838 18.1301 1.06219 18.1301H9.36057C9.95806 18.1301 10.4228 17.6432 10.4228 17.0679C10.4228 16.4704 9.95806 16.0057 9.36057 16.0057Z",
    fill: "#F7F8F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditInfo);
export default __webpack_public_path__ + "static/media/edit-info.534619bc615d3b0c01c8b642267393b6.svg";
export { ForwardRef as ReactComponent };